"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ServiceRegistry = _interopRequireDefault(require("../util/ServiceRegistry"));
var _ErrorUtils = require("../util/ErrorUtils");
var _APICommands = require("../constants/APICommands");
var _PreviewCommands = _interopRequireDefault(require("../commands/PreviewCommands"));
var _AppCommands = _interopRequireDefault(require("../commands/AppCommands"));
var _AnnotationCommands = _interopRequireDefault(require("../commands/AnnotationCommands"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2020 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
const getCommandType = data => {
  let commandType = "App"; // default type
  if (Object.values(_APICommands.AnnotationAPICommands).includes(data.command)) {
    commandType = "AnnotationAPICommand";
  } else if (Object.values(_APICommands.PreviewAPICommands).includes(data.command)) {
    commandType = "PreviewAPICommand";
  }
  return commandType;
};
const logEvent = (Command, data, options, services) => {
  const commandType = getCommandType(data);
  services.getService("LoggingService").logExternal("CommandReceiverService event Log, commandType: ", commandType, ", command: ", data.command, ", options: ", options);
  if (Command instanceof _AnnotationCommands.default) {
    services.getService("AnalyticsProviderService").logEvent({
      workflow: "PersonalCommentingAPI",
      subcategory: data.command,
      type: options.type
    });
  }
  if (options.type === "failed") {
    const errorLog = (0, _ErrorUtils.getErrorLog)(options.error);
    services.getService("LoggingService").error(Command.constructor.getClassName(), data.command, errorLog);
  }
};
class CommandReceiverService {
  constructor() {
    this._commands = {};
    this._getCommands = _objectSpread(_objectSpread(_objectSpread({}, this._getCommandsFor(_APICommands.PreviewAPICommands, _PreviewCommands.default)), this._getCommandsFor(_APICommands.AnnotationAPICommands, _AnnotationCommands.default)), this._getCommandsFor(_APICommands.AppAPICommands, _AppCommands.default));
  }
  _getCommandsFor(commands, APICommand) {
    return Object.keys(commands).reduce((obj, item) => _objectSpread(_objectSpread({}, obj), {}, {
      [item]: () => {
        const className = APICommand.getClassName();
        if (this._commands[className]) {
          return Promise.resolve(this._commands[className]);
        }
        this._commands[className] = new APICommand();
        return Promise.resolve(this._commands[className]);
      }
    }), {});
  }
  executeCommand(data) {
    return new Promise((resolve, reject) => {
      if (this._getCommands[data.command]) {
        this._getCommands[data.command]().then(Command => {
          logEvent(Command, data, {
            type: "invoked"
          }, _ServiceRegistry.default);
          Command.executeCommand(data).then(result => {
            logEvent(Command, data, {
              type: "succeeded"
            }, _ServiceRegistry.default);
            resolve(result);
          }).catch(error => {
            logEvent(Command, data, {
              type: "failed",
              error
            }, _ServiceRegistry.default);
            reject(error);
          });
        });
      } else {
        reject("Command not supported.");
      }
    });
  }
}
exports.default = CommandReceiverService;